module.exports = __webpack_public_path__ + "static/img/thhz_pc_bgc.2a5a42d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/thhz_pc_bgc.png
// module id = CMq9
// module chunks = 98